import React, { useState, useEffect, useContext } from 'react';
import PopupLayout from 'components/PopupLayout';
import PopupBonusReg from 'components/PopupBonusReg';
import BannerSlider from 'components/BannerSlider';
import BannerService from 'services/Banner/service';
import { constants } from 'config';
import { AuthContext } from '../../auth/AuthContext';

const Banner = () => {

    const { sessionData } = useContext(AuthContext);
    const [showBonus, setShowBonus] = useState(false);
    const [banners, setBanners] = useState([]);
    const openBonus = (event, forceValue = 'none') => {
        event.preventDefault();
        setShowBonus(forceValue === 'none' ? !showBonus : (forceValue));
    }
    useEffect(() => {
        if(!sessionData.logged){
            Promise.all([BannerService.public()]).then(bpublic => {
                if(bpublic && ['200', '201'].includes(bpublic[0].internalCode)){
                    setBanners(bpublic[0].payload);
                }
            });
        }else{
            if(sessionData.welcome){
                return;
            }
            getBannerLogged();
        }
    }, [sessionData]);

    const getBannerLogged = async () => {
        let bannersAll = [];
        let restBanner = constants.maxBanner;

        if(sessionData.logged && !sessionData.bonus){
            let bsBonus = await BannerService.bonus();
            if(bsBonus && ['200', '201'].includes(bsBonus.internalCode)){
                if(bsBonus.payload.length>1){
                    bsBonus.payload = getBannersRandom(bsBonus, 1);
                }

                if(bsBonus.payload.length){
                    bsBonus.payload[0].bonus = true;
                    bannersAll = bsBonus.payload;
                    restBanner -= constants.includeBonus;
                }
            }
        }

        let bsClient = await BannerService.client();
        if(bsClient && ['200', '201'].includes(bsClient.internalCode)){
            bsClient.payload = (bsClient.payload.length>restBanner) ? getBannersRandom(bsClient.payload, restBanner) : bsClient.payload;
            bannersAll = bannersAll.concat(bsClient.payload);
            restBanner -= bsClient.payload.length;
        }
 
        if(restBanner){
            const bsMassive = await BannerService.massive();
            if(bsMassive && ['200', '201'].includes(bsMassive.internalCode)){
                bannersAll = bannersAll.concat((bsMassive.payload.length>restBanner) ? getBannersRandom(bsMassive.payload, restBanner) : bsMassive.payload);                
            }
        }
        setBanners(bannersAll);
    }

    const getBannersRandom = (banners, n) => {
        let result = new Array(n),
            len = banners.length,
            taken = new Array(len);
        while (n--) {
            var x = Math.floor(Math.random() * len);
            result[n] = banners[x in taken ? taken[x] : x];
            taken[x] = --len in taken ? taken[len] : len;
        }
        return result;
    }

    return (
        <>
        <section className="header bg-default">
            <div className="container h-100">
                <div className="row h-100">
                    <div className="col-12 h-100 p-0 banner-slider">
                        <BannerSlider banners={banners} onBonusCase={openBonus} isLogged={sessionData.logged} />
                    </div>
                </div>
            </div>
        </section>
        {
        <PopupLayout isShowwing={showBonus} showingCallback={openBonus}>
            <PopupBonusReg execActionConfirm={openBonus} />
        </PopupLayout>
        }
        </>
    )
}

export default Banner;